import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";

interface ScannerPaperProps {
  hasError?: boolean;
}

export const IconContainer = styled("span")({
  display: "flex",
  alignItems: "center",
  marginLeft: "var(--space-sm)",
  marginRight: "var(--space-sm)",
});

export const ScannerPaper = styled(Paper, {
  shouldForwardProp: (prop) => prop !== "hasError",
})<ScannerPaperProps>(({ hasError }) => ({
  width: "100%",
  padding: "var(--space-xs)",
  display: "flex",
  alignItems: "center",
  transition: "border-color 0.3s ease, color 0.3s ease, background-color 0.3s ease",
  borderBottom: "2px solid var(--color-background-surface)",

  "&:hover": {
    color: hasError ? "var(--color-error)" : undefined,
    borderBottomColor: hasError ? "var(--color-error)" : undefined,
    backgroundColor: "var(--color-background-field-hover)",
  },
  "&:focus-within": {
    color: hasError ? "var(--color-error)" : undefined,
    borderBottomColor: hasError ? "var(--color-error)" : undefined,
    backgroundColor: "var(--color-background-field-hover)",
  },
}));
